import { render, staticRenderFns } from "./GovPanel.vue?vue&type=template&id=46ae57b2"
import script from "./GovPanel.vue?vue&type=script&lang=js"
export * from "./GovPanel.vue?vue&type=script&lang=js"
import style0 from "./GovPanel.vue?vue&type=style&index=0&id=46ae57b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports